export default __webpack_public_path__ + "static/media/Webinar.590504c2.png";